var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStackview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 46,
    rx: 23,
    stroke: "#2F1C0A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 11H25.25C24.388 11 23.5614 11.3424 22.9519 11.9519C22.3424 12.5614 22 13.388 22 14.25V33.75C22 34.612 22.3424 35.4386 22.9519 36.0481C23.5614 36.6576 24.388 37 25.25 37H38.25C39.112 37 39.9386 36.6576 40.5481 36.0481C41.1576 35.4386 41.5 34.612 41.5 33.75C42.362 33.75 43.1886 33.4076 43.7981 32.7981C44.4076 32.1886 44.75 31.362 44.75 30.5V17.5C44.75 16.638 44.4076 15.8114 43.7981 15.2019C43.1886 14.5924 42.362 14.25 41.5 14.25C41.5 13.388 41.1576 12.5614 40.5481 11.9519C39.9386 11.3424 39.112 11 38.25 11ZM41.5 15.875C41.931 15.875 42.3443 16.0462 42.649 16.351C42.9538 16.6557 43.125 17.069 43.125 17.5V30.5C43.125 30.931 42.9538 31.3443 42.649 31.649C42.3443 31.9538 41.931 32.125 41.5 32.125V15.875ZM23.625 14.25C23.625 13.819 23.7962 13.4057 24.101 13.101C24.4057 12.7962 24.819 12.625 25.25 12.625H38.25C38.681 12.625 39.0943 12.7962 39.399 13.101C39.7038 13.4057 39.875 13.819 39.875 14.25V33.75C39.875 34.181 39.7038 34.5943 39.399 34.899C39.0943 35.2038 38.681 35.375 38.25 35.375H25.25C24.819 35.375 24.4057 35.2038 24.101 34.899C23.7962 34.5943 23.625 34.181 23.625 33.75V14.25Z",
    fill: "#2F1C0A",
    stroke: "#2F1C0A",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackview);
export default __webpack_public_path__ + "static/media/stackview.0117130a325a39704fca07bb66883da2.svg";
export { ForwardRef as ReactComponent };